module.exports = {
  sliderData: () => {
    return {

      "TUCSON HEV LIMITED": {
        name: "TUCSON HEV",
        nameTitle: "TUCSON Híbrida",
        nameAlt: "TUCSONHíbrida",
		    preview: require('./../UI/carSlider/tucson_car.webp'),
        info: require('./../UI/carSlider/kona_info.webp'),
        bgColor: '#ECE8E5'
      },
      "VENUE": {
        name: "VENUE",
        nameTitle: "VENUE",
        nameAlt: "VENUE",
		    preview: require('./../UI/carSlider/venue_car.webp'),
        info: require('./../UI/carSlider/venue_info.webp'),
        bgColor: '#ECE8E5'
      },
      "SANTA FE": {
        name: "SANTA FE",
        nameTitle: "SANTA FE Híbrida",
        nameAlt: "SANTAFEHíbrida",
		    preview: require('./../UI/carSlider/santafe_car.webp'),
        info: require('./../UI/carSlider/santafe_info.webp'),
        bgColor: '#ECE8E5'
      },
      "KONA HEV": {
        name: "KONA HEV",
        nameTitle: "KONA Híbrida",
        nameAlt: "KONAHibrida",
		    preview: require('./../UI/carSlider/kona_car.webp'),
        info: require('./../UI/carSlider/kona_info.webp'),
        bgColor: '#ECE8E5'
      },
      "GRAND i10": {
        name: "GRAND i10",
        nameTitle: "GRAND i10",
        nameAlt: "GRANDi10",
		    preview: require('./../UI/carSlider/hyundai-portadilla-2-grand-i10.webp'),
        info: require('./../UI/carSlider/venue_info.webp'),
        bgColor: '#ECE8E5'
      },

      
      
      "CRETA": {
        name: "CRETA",
        nameTitle: "CRETA",
        nameAlt: "CRETA",
		    preview: require('./../UI/carSlider/creta_car.webp'),
        info: require('./../UI/carSlider/tucson_info.webp'),
        bgColor: '#ECE8E5'
      },
      
      "IONIQ 5": {
        name: "IONIQ 5",
        nameTitle: "IONIQ 5",
        nameAlt: "IONIQ5",
        preview: require('./../UI/carSlider/ioniq_car.webp'),
        info: require('./../UI/carSlider/ioniq_info.webp'),
        bgColor: '#ECE8E5'
      },
	    "PALISADE": {
        name: "PALISADE",
        nameTitle: "PALISADE",
        nameAlt: "PALISADE",
        preview: require('./../UI/carSlider/palisade_car.webp'),
        info: require('./../UI/carSlider/palisade_info.webp'),
        bgColor: '#ECE8E5'
      },
      "HB20": {
        name: "HB20",
        nameTitle: "HB20",
        nameAlt: "HB20",
        preview: require('./../UI/carSlider/HB20_car.webp'),
        info: require('./../UI/carSlider/HB20_info.webp'),
        bgColor: '#ECE8E5'
      },
      "HB20S": {
        name: "HB20S",
        nameTitle: "HB20S",
        nameAlt: "HB20S",
        preview: require('./../UI/carSlider/HB20S_car.webp'),
        info: require('./../UI/carSlider/HB20S_info.webp'),
        bgColor: '#ECE8E5'
      },
      "STARIA": {
        name: "STARIA",
        nameTitle: "STARIA",
        nameAlt: "STARIA",
        preview: require('./../UI/carSlider/staria_car.webp'),
        info: require('./../UI/carSlider/staria_info.webp'),
        bgColor: '#ECE8E5'
      },
    }
  }
}